import { createSelector } from 'reselect';

import { selectLoanApplication } from '../selectors';

export const selectFormTaskDraftFields = createSelector(
  selectLoanApplication,
  ({ formTask }) => formTask,
);
